export const FolderIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="24"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="square"
      strokeLinejoin="round"
      {...props}
    >
      <g id="Folder">
        <path
          id="Vector"
          d="M3 22C2.47005 21.9984 1.96227 21.7872 1.58753 21.4125C1.2128 21.0377 1.00158 20.5299 1 20V2H7L9 5H20V6"
        />
        <path
          id="Vector_2"
          d="M5 9V20C4.99842 20.5299 4.7872 21.0377 4.41247 21.4125C4.03773 21.7872 3.52995 21.9984 3 22H21C21.5299 21.9984 22.0377 21.7872 22.4125 21.4125C22.7872 21.0377 22.9984 20.5299 23 20V9H5Z"
        />
      </g>
    </svg>
  );
};
